import React, { Component } from 'react'
import './style.scss';

export default class HostAppsPage extends Component {
    render() {
        return (
            <div className='hostpage'>
             <div className='hostLink'>
                <a className='' href="../../images/tv.apk" download>
                <i class="fas fa-download" style={{marginRight:"1rem"}}></i>
                    Download APK FILE </a>
            </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/HostAppsPage/index.js